import { render, staticRenderFns } from "./DiskVideo.vue?vue&type=template&id=2de82f3a&scoped=true&"
import script from "./DiskVideo.vue?vue&type=script&lang=js&"
export * from "./DiskVideo.vue?vue&type=script&lang=js&"
import style0 from "./DiskVideo.vue?vue&type=style&index=0&id=2de82f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de82f3a",
  null
  
)

export default component.exports